<div (click)="onClick()" class="primary mapfre-hide-tablet mapfre-hide-mobile
    mapfre-mt-xxs mapfre-fs-xs mapfre-ml-xsm mapfre-mr-sm flex cp capitalize as-c">
    <span>{{ buttonText | translate }}</span>
</div>